export const getPhotoUrls = (isRunningInProd: boolean, photoKey: string) => {
  const environmentHost = isRunningInProd ? 'photos.zillowstatic.com' : 'photos.test.zillow.net';

  return {
    medium: `https://${environmentHost}/fp/${photoKey}-rentals_medium_500_500.webp`,
    thumb: `https://${environmentHost}/fp/${photoKey}-rentals_thumb_180_180.webp`,
  };
};

export const getIsRunningInProd = () =>
  typeof window !== 'undefined'
    ? window.location.hostname.includes('zillow.com') || window.location.hostname.includes('hotpads.com')
    : false;

export const getPhotoThumbUrl = (photoKey: string | undefined) => {
  if (!photoKey) {
    return '';
  }

  return getPhotoUrls(getIsRunningInProd(), photoKey).thumb;
};
